import script from "./ImageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageModal.vue?vue&type=script&setup=true&lang=js"

import "./ImageModal.vue?vue&type=style&index=0&id=82361b1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82361b1c"]])

export default __exports__